function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _wrapAsyncGenerator(e) { return function () { return new AsyncGenerator(e.apply(this, arguments)); }; }

function AsyncGenerator(e) { var r, t; function resume(r, t) { try { var n = e[r](t), o = n.value, u = o instanceof _OverloadYield; Promise.resolve(u ? o.v : o).then(function (t) { if (u) { var i = "return" === r ? "return" : "next"; if (!o.k || t.done) return resume(i, t); t = e[i](t).value; } settle(n.done ? "return" : "normal", t); }, function (e) { resume("throw", e); }); } catch (e) { settle("throw", e); } } function settle(e, n) { switch (e) { case "return": r.resolve({ value: n, done: !0 }); break; case "throw": r.reject(n); break; default: r.resolve({ value: n, done: !1 }); } (r = r.next) ? resume(r.key, r.arg) : t = null; } this._invoke = function (e, n) { return new Promise(function (o, u) { var i = { key: e, arg: n, resolve: o, reject: u, next: null }; t ? t = t.next = i : (r = t = i, resume(e, n)); }); }, "function" != typeof e.return && (this.return = void 0); }

AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, AsyncGenerator.prototype.next = function (e) { return this._invoke("next", e); }, AsyncGenerator.prototype.throw = function (e) { return this._invoke("throw", e); }, AsyncGenerator.prototype.return = function (e) { return this._invoke("return", e); };

function _awaitAsyncGenerator(e) { return new _OverloadYield(e, 0); }

function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }

function _asyncGeneratorDelegate(t) { var e = {}, n = !1; function pump(e, r) { return n = !0, r = new Promise(function (n) { n(t[e](r)); }), { done: !1, value: new _OverloadYield(r, 1) }; } return e["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function () { return this; }, e.next = function (t) { return n ? (n = !1, t) : pump("next", t); }, "function" == typeof t.throw && (e.throw = function (t) { if (n) throw n = !1, t; return pump("throw", t); }), "function" == typeof t.return && (e.return = function (t) { return n ? (n = !1, t) : pump("return", t); }), e; }

function _OverloadYield(e, d) { this.v = e, this.k = d; }

import getFilesAndDirectoriesFromDirectory from './getFilesAndDirectoriesFromDirectory.js';
/**
 * Polyfill for the new (experimental) getAsFileSystemHandle API (using the popular webkitGetAsEntry behind the scenes)
 * so that we can switch to the getAsFileSystemHandle API once it (hopefully) becomes standard
 */

function getAsFileSystemHandleFromEntry(entry, logDropError) {
  if (entry == null) return entry;
  return {
    // eslint-disable-next-line no-nested-ternary
    kind: entry.isFile ? 'file' : entry.isDirectory ? 'directory' : undefined,
    name: entry.name,
    getFile: function getFile() {
      return new Promise(function (resolve, reject) {
        return entry.file(resolve, reject);
      });
    },
    values: function values() {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var directoryReader, entries;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // If the file is a directory.
                directoryReader = entry.createReader();
                _context.next = 3;
                return _awaitAsyncGenerator(new Promise(function (resolve) {
                  getFilesAndDirectoriesFromDirectory(directoryReader, [], logDropError, {
                    onSuccess: function onSuccess(dirEntries) {
                      return resolve(dirEntries.map(function (file) {
                        return getAsFileSystemHandleFromEntry(file, logDropError);
                      }));
                    }
                  });
                }));

              case 3:
                entries = _context.sent;
                return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(entries), _awaitAsyncGenerator), "t0", 5);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  };
}

function createPromiseToAddFileOrParseDirectory(_x, _x2, _x3) {
  return _createPromiseToAddFileOrParseDirectory.apply(this, arguments);
}
/**
 * Load all files from data transfer, and recursively read any directories.
 * Note that IE is not supported for drag-drop, because IE doesn't support Data Transfers
 *
 * @param {DataTransfer} dataTransfer
 * @param {*} logDropError on error
 */


function _createPromiseToAddFileOrParseDirectory() {
  _createPromiseToAddFileOrParseDirectory = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(entry, relativePath, lastResortFile) {
    var file, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, handle;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (lastResortFile === void 0) {
              lastResortFile = undefined;
            } // For each dropped item, - make sure it's a file/directory, and start deepening in!


            if (!(entry.kind === 'file')) {
              _context2.next = 16;
              break;
            }

            _context2.next = 4;
            return _awaitAsyncGenerator(entry.getFile());

          case 4:
            file = _context2.sent;

            if (!(file != null)) {
              _context2.next = 11;
              break;
            }

            file.relativePath = relativePath ? "".concat(relativePath, "/").concat(entry.name) : null;
            _context2.next = 9;
            return file;

          case 9:
            _context2.next = 14;
            break;

          case 11:
            if (!(lastResortFile != null)) {
              _context2.next = 14;
              break;
            }

            _context2.next = 14;
            return lastResortFile;

          case 14:
            _context2.next = 50;
            break;

          case 16:
            if (!(entry.kind === 'directory')) {
              _context2.next = 47;
              break;
            }

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 19;
            _iterator = _asyncIterator(entry.values());

          case 21:
            _context2.next = 23;
            return _awaitAsyncGenerator(_iterator.next());

          case 23:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 29;
              break;
            }

            handle = _step.value;
            return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(createPromiseToAddFileOrParseDirectory(handle, "".concat(relativePath, "/").concat(entry.name))), _awaitAsyncGenerator), "t0", 26);

          case 26:
            _iteratorAbruptCompletion = false;
            _context2.next = 21;
            break;

          case 29:
            _context2.next = 35;
            break;

          case 31:
            _context2.prev = 31;
            _context2.t1 = _context2["catch"](19);
            _didIteratorError = true;
            _iteratorError = _context2.t1;

          case 35:
            _context2.prev = 35;
            _context2.prev = 36;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.next = 40;
              break;
            }

            _context2.next = 40;
            return _awaitAsyncGenerator(_iterator.return());

          case 40:
            _context2.prev = 40;

            if (!_didIteratorError) {
              _context2.next = 43;
              break;
            }

            throw _iteratorError;

          case 43:
            return _context2.finish(40);

          case 44:
            return _context2.finish(35);

          case 45:
            _context2.next = 50;
            break;

          case 47:
            if (!(lastResortFile != null)) {
              _context2.next = 50;
              break;
            }

            _context2.next = 50;
            return lastResortFile;

          case 50:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[19, 31, 35, 45], [36,, 40, 44]]);
  }));
  return _createPromiseToAddFileOrParseDirectory.apply(this, arguments);
}

export default function getFilesFromDataTransfer(_x4, _x5) {
  return _getFilesFromDataTransfer.apply(this, arguments);
}

function _getFilesFromDataTransfer() {
  _getFilesFromDataTransfer = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dataTransfer, logDropError) {
    var fileSystemHandles, _iterator2, _step2, _ref3, lastResortFile, fileSystemHandle;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _awaitAsyncGenerator(Promise.all(Array.from(dataTransfer.items, /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(item) {
                var _fileSystemHandle, fileSystemHandle, getAsEntry;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        // TODO enable getAsFileSystemHandle API once we can get it working with subdirectories
                        // IMPORTANT: Need to check isSecureContext *before* calling getAsFileSystemHandle
                        // or else Chrome will crash when running in HTTP: https://github.com/transloadit/uppy/issues/4133
                        // if (window.isSecureContext && item.getAsFileSystemHandle != null) entry = await item.getAsFileSystemHandle()
                        // `webkitGetAsEntry` exists in all popular browsers (including non-WebKit browsers),
                        // however it may be renamed to getAsEntry() in the future, so you should code defensively, looking for both.
                        // from https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry
                        getAsEntry = function getAsEntry() {
                          return typeof item.getAsEntry === 'function' ? item.getAsEntry() : item.webkitGetAsEntry();
                        }; // eslint-disable-next-line prefer-const


                        // eslint-disable-next-line prefer-const
                        (_fileSystemHandle = fileSystemHandle) != null ? _fileSystemHandle : fileSystemHandle = getAsFileSystemHandleFromEntry(getAsEntry(), logDropError);
                        return _context3.abrupt("return", {
                          fileSystemHandle: fileSystemHandle,
                          lastResortFile: item.getAsFile() // can be used as a fallback in case other methods fail

                        });

                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x6) {
                return _ref.apply(this, arguments);
              };
            }())));

          case 2:
            fileSystemHandles = _context4.sent;
            _iterator2 = _createForOfIteratorHelper(fileSystemHandles);
            _context4.prev = 4;

            _iterator2.s();

          case 6:
            if ((_step2 = _iterator2.n()).done) {
              _context4.next = 30;
              break;
            }

            _ref3 = _step2.value;
            lastResortFile = _ref3.lastResortFile;
            fileSystemHandle = _ref3.fileSystemHandle;

            if (!(fileSystemHandle != null)) {
              _context4.next = 25;
              break;
            }

            _context4.prev = 11;
            return _context4.delegateYield(_asyncGeneratorDelegate(_asyncIterator(createPromiseToAddFileOrParseDirectory(fileSystemHandle, '', lastResortFile)), _awaitAsyncGenerator), "t0", 13);

          case 13:
            _context4.next = 23;
            break;

          case 15:
            _context4.prev = 15;
            _context4.t1 = _context4["catch"](11);

            if (!(lastResortFile != null)) {
              _context4.next = 22;
              break;
            }

            _context4.next = 20;
            return lastResortFile;

          case 20:
            _context4.next = 23;
            break;

          case 22:
            logDropError(_context4.t1);

          case 23:
            _context4.next = 28;
            break;

          case 25:
            if (!(lastResortFile != null)) {
              _context4.next = 28;
              break;
            }

            _context4.next = 28;
            return lastResortFile;

          case 28:
            _context4.next = 6;
            break;

          case 30:
            _context4.next = 35;
            break;

          case 32:
            _context4.prev = 32;
            _context4.t2 = _context4["catch"](4);

            _iterator2.e(_context4.t2);

          case 35:
            _context4.prev = 35;

            _iterator2.f();

            return _context4.finish(35);

          case 38:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[4, 32, 35, 38], [11, 15]]);
  }));
  return _getFilesFromDataTransfer.apply(this, arguments);
}